import { SidePanel } from 'components/UI';
import { Payment } from '@spike/payments-model';
import { FunctionComponent } from 'react';
import Receipt from 'components/UI/Receipt/Receipt';

interface ReceiptViewProps {
    payment: Payment;
    onBack: () => void;
}

export const ReceiptView: FunctionComponent<ReceiptViewProps> = props => {
    return (
        <SidePanel
            side="right"
            showCloseButton={true}
            onClose={props.onBack}
        >
            <div style={{ width: '100%', height: '100%' }}>
                <Receipt
                    payment={props.payment}
                    onBack={props.onBack}
                />
            </div>
        </SidePanel>
    );
};

export default ReceiptView;
